// LocaleUrlSerializer — DESIGN §2.1, wariant B-full.
//
// Rola: prefiks locale jest zdejmowany WEWNATRZ Angulara, zanim router dopasuje trase,
// i doklejany z powrotem przy kazdym serialize() — dzieki temu `main-routing.module.ts`
// nie wie o zadnym `/en`, a KAZDY routerLink / router.navigate() dostaje prefiks za darmo.
//
// Trzy twarde wlasciwosci (kazda ma test w locale-url.serializer.spec.ts):
//  1. 🔴 Prefiks ustalany DOKLADNIE RAZ, w konstruktorze — nigdy per-wywolanie.
//     Silnik przepuszcza przez TEN SAM serializer adres zadania i koncowy adres routera,
//     a gdy wyniki sie roznia, zwraca 302 (ssr.mjs:156-176, constructSerializedUrl:210-225).
//     Prefiks liczony z serializowanego stringa = przekierowanie strony na sama siebie = petla (§11.11).
//  2. parse ∘ serialize jest idempotentne na OBU platformach.
//  3. 🔴 Musi przezyc `pathname === '/'` BEZ providera REQUEST (F6) — w tym stanie startuje
//     build-time route extraction, a wyjatek w konstruktorze wywraca BUILD, nie strone
//     (errors[] z ekstrakcji rzuca, ssr.mjs:929-932).
import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

import { splitLocalePrefix } from './detect-locale';
import { readCurrentUrlOnce } from './current-url';

@Injectable()
export class LocaleUrlSerializer extends DefaultUrlSerializer {
  /** '' (PL — H6: polski NIE ma prefiksu) albo 'en'. Ustalane RAZ, w konstruktorze. */
  private readonly prefix: '' | 'en';

  constructor() {
    super();
    // Zrodlo prefiksu = ADRES (wariant B, F1). Odczyt adresu z DI zyje w
    // current-url.ts — TEN SAM kanal czyta przelacznik jezyka (T8), zeby nie
    // powstala druga, rozjezdzajaca sie implementacja "gdzie jestesmy".
    this.prefix = splitLocalePrefix(readCurrentUrlOnce()).prefix;
  }

  override parse(url: string): UrlTree {
    // Zachlanne zdjecie prefiksu — to samo parsowanie co w detect-locale i (docelowo) w Express.
    // Robimy to bezwarunkowo, takze gdy this.prefix === '': adres /pl/... i tak nie ma trasy,
    // a rozjazd miedzy platformami bierze sie wlasnie z warunkowego zdejmowania.
    return super.parse(splitLocalePrefix(url).rest);
  }

  override serialize(tree: UrlTree): string {
    const serialized = super.serialize(tree);
    if (!this.prefix) {
      return serialized;
    }
    // this.prefix, nie prefiks wyliczony z `serialized` — to jest cala pointa wlasnosci 1.
    const bare = splitLocalePrefix(serialized).rest;
    return `/${this.prefix}${bare === '/' ? '/' : bare}`;
  }
}
